import { render, staticRenderFns } from "./PreorderTable.vue?vue&type=template&id=b21b7b06&scoped=true&"
import script from "./PreorderTable.vue?vue&type=script&lang=js&"
export * from "./PreorderTable.vue?vue&type=script&lang=js&"
import style0 from "./PreorderTable.vue?vue&type=style&index=0&id=b21b7b06&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b21b7b06",
  null
  
)

export default component.exports